var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 39,
    viewBox: "0 0 48 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9944 33.2026C12.2247 38.4699 3.28551 37.0211 1.71395 28.4313C0.14238 19.8415 7.57798 17.9464 9.4065 14.799C11.9725 10.3822 10.6096 2.44289 18.9722 1.8818C27.5117 1.30884 24.9591 11.5303 31.9723 11.3818C55.4723 10.884 47.4722 36.921 34.4731 34.079C28.1231 32.6906 22.6903 26.9127 16.9944 33.2026Z",
    fill: "#D7E8F0",
    stroke: "#D7E8F0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65866 6.38184C13.6622 6.38184 13.2773 11.0681 13.2773 11.0681",
    stroke: "#1D47B1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2742 37.3119C22.9657 37.3119 23.1577 32.7484 23.1577 32.7484L40.4629 32.7484C40.2792 37.1304 36.0886 37.3119 36.0886 37.3119L18.2658 37.3119C15.4943 37.3119 13.2487 35.0921 13.2487 32.3523L13.2487 11.4905L2.97247 11.4905C2.97247 8.66821 5.28484 6.38232 8.13982 6.38232L26.8141 6.38232C29.6273 6.38232 31.8979 8.6352 31.8979 11.408L31.8979 32.6824",
    stroke: "#1D47B1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2783 12.9429L17.0312 12.9429",
    stroke: "#1D47B1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2783 17.6294L17.0312 17.6294",
    stroke: "#1D47B1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2783 22.3159L17.0312 22.3159",
    stroke: "#1D47B1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2783 27.002L17.0312 27.002",
    stroke: "#1D47B1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.4cea1b4398cfee53c8691dd9c93183e8.svg";
export { ForwardRef as ReactComponent };